import './abstract_section_view.coffee'
Namespace('Monitoring.Reports.Executive')

class Monitoring.Reports.Executive.PieChartView extends Monitoring.Reports.Executive.AbstractSectionView
  genericTemplate: JST["backbone/templates/monitoring/reports/executive/generic_template"]
  pieTemplate: JST["backbone/templates/monitoring/reports/executive/interactions_pie"]
  tagName: 'section'
  id: 'fb-interactions'
  chartClass: 'interactions-pie-container'
  icon: 'pie'

  initialize: (@options = {}) ->
    @colors = @options.colors
    @target = { 
      fans: @options.chartApi.fans_gender, 
      fb_reach: (@options.chartApi.channel_reach + "facebook"), 
      tw_reach: (@options.chartApi.channel_reach + "twitter"), 
      impressions: @options.chartApi.fb_page_impressions, 
      fb_posts: (@options.chartApi.channel_organic_paid_posts + "facebook"), 
      tw_posts: (@options.chartApi.channel_organic_paid_posts + "twitter"), 
      fb_interactions: (@options.chartApi.channel_interactions + "facebook"), 
      tw_interactions: (@options.chartApi.channel_interactions + "twitter")
      yt_interactions: (@options.chartApi.channel_interactions + "youtube")
      tw_sentiment:  (@options.chartApi.sentiment + "twitter")
    }
    @title = null

  interactionOptions: (response, divId) =>
    series = response.series
    series[0].type = 'pie'
    for point in series[0].data
      point.color = @colors[point.code]
    {
      chart:
        backgroundColor: null
        renderTo: @$el.find(divId).get(0)
        height: 400
        width: 500
        spacing: [0, 0, 0, 0]
      series: series
      legend:
        enabled: true
        align: 'right'
        verticalAlign: 'middle'
        layout: 'vertical'
      tooltip: 
        pointFormat: 'Total: {point.y}'
      plotOptions:
        pie:
          dataLabels:
            enabled: false
          showInLegend: true
      exporting:
        enabled: false
      title:
        text: @title
    }

  render: ->
    @bindChartsReady(1)
    @$el.html(@genericTemplate(self: this))
    @$el.find('.chart_container').html(@pieTemplate())

    query = @labelsQuery(@labelFilter(), @labelsStructure())
    @$el.find('.interactions-pie').addClass('processing')

    fb_page = @getTemplateOptions().page
    $.post(@target[@getTemplateOptions().dimension], _.extend({page: fb_page}, query), (response) =>
      if @getTemplateOptions().dimension == "fans"
        @_format_fans(response)
      else
        @_render_data(response)
    )

  _render_data: (data) ->
    count = 0 
    for object in data.series[0]["data"]
      count += object.y
    for object in data.series[0]["data"]
      percentage = ((object.y/count) *100).toFixed(2) if count > 0 
      object.name = object.name + " (" + percentage + "%)"
    if count > 0
      @title = "Total de interacciones: " + data.total if @getTemplateOptions().dimension.indexOf("interactions") != -1
      @drawChart(data, '.interactions-pie', @interactionOptions, { prepareColors: @prepareColors } )
      @$el.find('.interactions-pie').find('.highcharts-container').css("margin" , "0pt auto")      

  _format_fans: (response) ->    
    male = 0
    female = 0
    unknown = 0
    for k,v of response
      if k[0] == "M"
        male += v
      else if k[0] == "F"
        female += v
      else
        unknown += v
    data = [{code: "masculino", name: "Male", y: male}, {code: "femenino", name: "Female", y: female}, {code: "desconocido", name: "Unknown", y: unknown}]
    formated_data = {series: [{data: data}]}
    @_render_data(formated_data)
